import React from 'react';
import { BaseTimelineItemFormLayout } from 'framework/ui/timeline';
import ProjectNoteForm from './ProjectNoteForm';
import useProjectNotesService from '../useProjectNotesService';
import { CreateForm, FormFieldsData, FormTemplateProps } from 'framework/form';

interface CreateProjectUserNoteFormProps extends Omit<FormTemplateProps, 'children'> {
  onCancel: () => void;
  submitFormFunc: (values: FormFieldsData) => Promise<object | void>;
}

const CreateProjectUserNoteForm = ({ submitFormFunc, onCancel, ...props }: CreateProjectUserNoteFormProps) => {
  const { getNoteValidationSchema } = useProjectNotesService();
  return (
    <CreateForm submitFormFunc={submitFormFunc} getValidationSchemaFunc={getNoteValidationSchema} {...props}>
      <BaseTimelineItemFormLayout isCreateForm onCancel={onCancel}>
        <ProjectNoteForm />
      </BaseTimelineItemFormLayout>
    </CreateForm>
  );
};

export default CreateProjectUserNoteForm;
